import { baseClasses } from '@weatherbug/common';
import type { Story } from '../../../components/common/interfaces/types';
import type { GetNewsStoriesActionParams, GetNewsStoriesByDateActionParams } from './types';
import { StoriesProvider } from '../../providers/stories/storiesProvider';

const { AsyncAction } = baseClasses;
export const GET_NEWS_STORIES = new AsyncAction('GET_NEWS_STORIES');
export const GET_NEWS_STORIES_BY_DATE = new AsyncAction('GET_NEWS_STORIES_BY_DATE');

export type GetNewsStoriesActionType = {
    type: typeof GET_NEWS_STORIES;
    payload: Promise<Story[]>;
}

export type GetNewsStoriesByDateActionType = {
    type: typeof GET_NEWS_STORIES_BY_DATE;
    payload: Promise<Story[]>;
}

export function getNewsStories({ baseUrl, category, count, content, tags }: GetNewsStoriesActionParams): GetNewsStoriesActionType {
    return {
        type: GET_NEWS_STORIES.base,
        payload: getNewsStoriesAsync({ baseUrl, category, count, content, tags }) 
    };
}

async function getNewsStoriesAsync({ baseUrl, category, count, content, tags }: GetNewsStoriesActionParams): Promise<Story[]> {
    const op = new StoriesProvider(baseUrl);
    return await op.getNewsStories({ category, count, content, tags });
}

export function getNewsStoriesByDate({ baseUrl, startTime, endTime, order, count, featured, index, isVideoPage }: GetNewsStoriesByDateActionParams): GetNewsStoriesByDateActionType  {
    return {
        type: GET_NEWS_STORIES_BY_DATE.base,
        payload: getNewsStoriesByDateAsync({ baseUrl, startTime, endTime, order, count, featured, index, isVideoPage })
    };
}

async function getNewsStoriesByDateAsync({ baseUrl, startTime, endTime, order, count, featured, index, isVideoPage }: GetNewsStoriesByDateActionParams): Promise<Story[]> {
    const op = new StoriesProvider(baseUrl);
    return await op.getNewsStoriesByDate({ startTime, endTime, order, count, featured, index, isVideoPage });
}